import { links } from "./links";
import insta from "../images/insta.svg";
import fb from "../images/fb.png";
import calendar from "../images/calendar.svg";
import mail from "../images/mail.svg";

// Where to find DAWC. Shared by the Join page's chips and the footer, so a new
// channel is added once. Previously these URLs were pasted inline in both
// Join.tsx's prose and MediaLinks.tsx.

/** A place to follow the campaign. */
export interface Channel {
  id: string;
  label: string;
  url: string;
  /** Imported icon asset. */
  icon: string;
}

export const channelsLeadIn = "Keep up with us";

/** Places to follow along. */
export const channels: Channel[] = [
  { id: "instagram", label: "Instagram", url: links.instagram, icon: insta },
  { id: "facebook", label: "Facebook", url: links.facebook, icon: fb },
  { id: "calendar", label: "Events calendar", url: links.calendar, icon: calendar },
  { id: "mailing-list", label: "Mailing list", url: links.mailingList, icon: mail },
];

/** The footer also offers a direct way to reach us, which "follow along" is not. */
export const footerChannels: Channel[] = [
  ...channels,
  { id: "email", label: "Email us", url: links.email, icon: mail },
];
